import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import {
  StepButtonControlTypes,
  StepButtonShapes,
  StepButtons,
  StepElementTypes,
  StepEmulatorDeviceWidths,
  StepEmulatorDevices,
  StepFixedMediaCategory,
  StepLayout,
  StepMedia,
  StepMediaCategory,
  StepMediaPanels,
  StepProductsPreview,
  StepResponseMedia,
  StepResponseScreen,
  StepTextual,
  StepTextualLayout,
  transparent,
  getCampaignProductImageUrl,
  Campaign,
  StepImagesLayout,
  StepPreviewButtonDetails,
  getFunnelPathVariables,
  CampaignProduct,
  StepSectionWidths,
  DiscountSetting,
  StepElements,
  CustomStepCategoryEnum,
  Pager,
  RelatedProductSet,
  ExchangeableProductsSet,
  FunnelInputTypeEnum,
  StepCategory,
  QuantityTypeEnum,
  VariantTypeEnum,
} from '../../../_models';
import { FormArray, FormGroup } from '@angular/forms';
import {forkJoin, Subscription } from 'rxjs';
import {
  StepEmulatorService,
  StepTemplateService,
  AlertService,
  ExchangeableProductsSetService,
  RelatedProductSetService,
  CampaignService,
  CampaignProductService,
  StorageService, WidgetService,
} from '../../../_services';
import {
  addDummyValues,
  buttonLayoutSteps,
  defaultRejectButtonStyles,
  defaultConfirmButtonStyles,
  getEmbeddedVideoUrl,
  isDirectVideoFile,
  setEmulatorWidth,
  updateFontSizes,
} from '../../step-util';
import { Form } from '../../../_forms';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { config } from '../../../../config/config';

@Component({
  selector: 'app-step-emulator',
  templateUrl: './step-emulator.component.html',
  styleUrls: ['./step-emulator.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class StepEmulatorComponent extends Form implements OnInit, OnDestroy, OnChanges {
  @Input() layout: StepLayout[] = [];
  @Input() form: FormGroup;
  @Input() isResponseScreen: boolean = false;
  @Input() activeDevice: StepEmulatorDevices;
  @Input() productPlaceholderUrl: string;
  @Input() theme: string;
  @Input() preview: boolean = false;
  @Input() partialEdit: boolean = false; // For Retention Settings
  @Input() isResponseCancellation: boolean = false;
  @Input() useExternalButtons = false;
  @Input() product: CampaignProduct = {} as CampaignProduct;
  @Input() discount: DiscountSetting;
  @Input() isInteractive: boolean = false;
  @Input() stepType: StepCategory;
  @Input() confirmationStepType: string = '';
  @Input() isPopup: boolean = false;
  @Input() isSingleStepOffer: boolean = false;
  @Input() isSurveyStep: boolean = false;
  campaign: Campaign;
  selectedCampaignProduct: CampaignProduct = null;
  private cachedGroupedVariants: { optionName: string; variants: any[] }[] = [];
  private lastCampaignProductId: any = null;
  campaignProductLoading: boolean = false;
  stepCategory = CustomStepCategoryEnum;
  funnelInputTypeEnum = FunnelInputTypeEnum;
  stepTextual: StepTextual;
  stepMedia: StepMedia;
  stepResponseMedia: StepResponseMedia;
  stepButtons: StepButtons;
  stepResponseScreen: StepResponseScreen;
  stepProductsPreview: StepProductsPreview = { data: [], loading: true };
  private subscriptions: Subscription[] = [];
  hasSurveyOptions: boolean;
  hasTimeOptions: boolean;
  selectedImage: string;
  selectedResponseImage: string;
  videoUrl: SafeResourceUrl;
  responseVideoUrl: SafeResourceUrl;
  loading: boolean = true;
  stepMediaCategory = StepMediaCategory;
  stepElements = StepElements;
  stepEmulatorDevices = StepEmulatorDevices;
  isPreviewMediaEnabled = true;
  noStepMedia = false;
  noPreviewMedia = false;
  noResponseMedia = false;
  placeholder: string = '';
  previewImage = '';
  isPreviewEmbed = false;
  previewEmbedUrl = '';
  previewEmbedIsFile = false;
  previewEmbedSanitized: SafeResourceUrl = null;
  previewConfirmButton: StepPreviewButtonDetails = {
    label: '',
    backgroundColor: '',
    color: '',
    borderRadius: '',
    borderColor: '',
  };
  previewRejectButton: StepPreviewButtonDetails = {
    label: '',
    backgroundColor: '',
    color: '',
    borderRadius: '',
    borderColor: '',
  };
  outlineShapes = [StepButtonShapes.FlatOutline, StepButtonShapes.ModernOutline, StepButtonShapes.PillOutline];
  funnelPathVariables: { value: string; text: string }[] = [];
  actions: FormGroup;
  exchangeableSets: ExchangeableProductsSet[] = [];
  relatedProductSets: { id: number | string; text: string }[];
  exchangeableSetTypes: { id: number | string; text: string }[] = [];
  unassignedExchangeableSets: ExchangeableProductsSet[] = [];
  @ViewChild('emulatorRef', { static: false }) emulatorRef: ElementRef;
  stepSectionWidths = StepSectionWidths;
  stepMediaPanels = StepMediaPanels;
  quantityType = QuantityTypeEnum;
  variantTypeEnum = VariantTypeEnum;
  shouldShowQuantityDropdown: boolean = false;
  shouldShowPlaceholderProducts: boolean = false;
  placeholderProducts: { id: number; name: string }[] = [
    { id: 1, name: 'Product name 1' },
    { id: 2, name: 'Product name 2' },
    { id: 3, name: 'Product name 3' },
  ];
  variantSelections: { [key: string]: string } = {};

  // Cache for preview mode values
  private cachedBanner: SafeHtml;
  private cachedLabel: SafeHtml;
  private cachedSubtitle: SafeHtml;
  private cachedContent: SafeHtml;
  private cachedHasSubtitle: boolean = false;
  private cachedHasContent: boolean = false;
  private cacheInitialized = false;

  constructor(
    private sanitizer: DomSanitizer,
    protected stepService: StepTemplateService,
    protected relatedProductSetService: RelatedProductSetService,
    protected exchangeablesSetService: ExchangeableProductsSetService,
    protected alertService: AlertService,
    protected router: Router,
    protected location: Location,
    private stepEmulatorService: StepEmulatorService,
    protected campaignService: CampaignService,
    protected campaignProductService: CampaignProductService,
    protected storageService: StorageService,
    protected widgetService: WidgetService
  ) {
    super(alertService, router, location);
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.loading = false;
    }, 4000);

    this.campaign = this.campaignService.getCurrentCampaign();
    this.stepEmulatorService.resetStepData();
    this.funnelPathVariables = getFunnelPathVariables();
    this.selectedCampaignProduct = this.product;

    const surveyOptions = this.layout.find((element) => element.type === StepElementTypes.SurveyOptions);
    this.hasSurveyOptions = surveyOptions ? true : false;

    const timeOptions = this.layout.find((element) => element.type === StepElementTypes.TimeOptions);
    this.hasTimeOptions = timeOptions ? true : false;

    const textSubscription = this.stepEmulatorService.stepTextual$.subscribe((data) => {
      this.stepTextual = data;
    });
    this.addSubscription(textSubscription);

    const stepMediaSubscription = this.stepEmulatorService.stepMedia$.subscribe((data) => {
      this.stepMedia = data;
      this.extractStepMedia();
    });
    this.addSubscription(stepMediaSubscription);

    const responseMediaSubscription = this.stepEmulatorService.stepResponseMedia$.subscribe((data) => {
      this.stepResponseMedia = data;
      this.extractResponseMedia();
    });
    this.addSubscription(responseMediaSubscription);

    const buttonsSubscription = this.stepEmulatorService.stepButtons$.subscribe((data) => {
      this.stepButtons = data;
    });
    this.addSubscription(buttonsSubscription);

    const responseScreenSubscription = this.stepEmulatorService.stepResponseScreen$.subscribe((data) => {
      this.stepResponseScreen = data;
    });
    this.addSubscription(responseScreenSubscription);

    const productsPreviewSubscription = this.stepEmulatorService.stepProductsPreview$.subscribe((data) => {
      this.stepProductsPreview = data;
      this.updateExchangeableUIStates();
    });
    this.addSubscription(productsPreviewSubscription);

    /* For Exchangeables */
    if (this.stepType === CustomStepCategoryEnum.ReviseOrder) {
      const inputs = this.form.get('inputs') as FormArray;
      const firstInput = inputs.at(0) as FormGroup;
      this.actions = (firstInput.get('actions') as FormArray).at(0) as FormGroup;
      this.updateExchangeableUIStates();

      // Listen for quantity_type changes to update UI reactively
      if (this.actions.get('quantity_type')) {
        const quantityTypeSubscription = this.actions.get('quantity_type').valueChanges.subscribe(() => {
          this.updateExchangeableUIStates();
        });
        this.addSubscription(quantityTypeSubscription);
      }
    }

    this.applyThemeColor(this.theme);

    /* Emulator Preview Settings */
    if (this.preview) {
      /* Media */
      const staticData = this.form.get('static_data');
      if (staticData) {
        const { embed_code, image, image_tablet, image_mobile, image_type } = staticData.value;
        if (image_type === StepMediaCategory.NoMedia) {
          this.isPreviewMediaEnabled = false;
        }

        const mediaElement = this.layout.find((element) => element.type === StepElementTypes.Media);
        this.placeholder =
          this.productPlaceholderUrl ||
          (mediaElement ? (mediaElement.layout as StepImagesLayout).placeholderImage : '');

        if (!embed_code && !image && !image_tablet && !image_mobile) {
          this.noPreviewMedia = true;
        } else if (image || image_tablet || image_mobile) {
          this.previewImage = image_mobile.file || image_tablet.file || image.file;
        } else if (embed_code) {
          this.isPreviewEmbed = true;
          this.previewEmbedUrl = embed_code;
          this.previewEmbedIsFile = isDirectVideoFile(embed_code);
          this.previewEmbedSanitized = getEmbeddedVideoUrl(embed_code, this.sanitizer);
        }
      }

      /* Preview Buttons */
      this.setupPreviewButtons();
      const inputs = this.form.get('inputs') as FormArray;
      if (inputs) {
        inputs.valueChanges.subscribe(() => {
          this.setupPreviewButtons();
        });
      }
    }
  }

  setupPreviewButtons() {
    if (this.useExternalButtons) {
      const buttonStylesGroup = this.form.get('button_styles') as FormGroup;
      const inputs = this.form.get('inputs') as FormArray;

      const confirmControl = buttonStylesGroup ? buttonStylesGroup.get('confirm') : null;
      const confirmValue = confirmControl && confirmControl.value ? confirmControl.value : {};
      const confirmStyles = confirmValue && confirmValue.style ? confirmValue.style : defaultConfirmButtonStyles.style;
      const confirmLabel = confirmValue && confirmValue.label ? confirmValue.label : '';

      this.previewConfirmButton = {
        label: this.getHtml(addDummyValues(confirmLabel, this.funnelPathVariables, this.product, this.discount)),
        ...this.extractButtonStyles(confirmStyles),
      };

      let rejectControl, rejectStyles, rejectValue, rejectLabel;
      if (
        this.stepType === CustomStepCategoryEnum.AdjustShippingFrequency ||
        this.stepType === CustomStepCategoryEnum.AdjustTrialFrequency ||
        this.stepType === CustomStepCategoryEnum.PauseSurvey
      ) {
        rejectControl = inputs.at(inputs.length - 1) as FormGroup;
        rejectValue = rejectControl && rejectControl.value ? rejectControl.value : {};
        rejectStyles =
          rejectValue && rejectValue.button_styles ? rejectValue.button_styles.style : defaultRejectButtonStyles.style;
        rejectLabel = rejectValue && rejectValue.label ? rejectValue.label : '';
      }

      this.previewRejectButton = {
        label: this.getHtml(addDummyValues(rejectLabel, this.funnelPathVariables, this.product, this.discount)),
        ...this.extractButtonStyles(rejectStyles),
      };
    } else {
      const inputs = this.form.get('inputs') as FormArray;
      let confirmLabel = '';
      if (this.stepType !== FunnelInputTypeEnum.Confirmation) {
        confirmLabel = inputs.at(0).get('label').value;
      } else {
        if (this.form.get('type').value === FunnelInputTypeEnum.InputActionStatus) {
          confirmLabel = inputs.at(0).get('label').value;
        } else {
          confirmLabel = inputs.at(1).get('label').value;
        }
      }
      const confirmButtonStyles =
        inputs.at(0).value.button_styles && inputs.at(0).value.button_styles.style
          ? inputs.at(0).value.button_styles.style
          : defaultConfirmButtonStyles.style;

      this.previewConfirmButton = {
        label: this.getHtml(addDummyValues(confirmLabel, this.funnelPathVariables, this.product, this.discount)),
        ...this.extractButtonStyles(confirmButtonStyles),
      };

      if (this.form.get('type').value !== FunnelInputTypeEnum.InputActionStatus) {
        const rejectLabel =
          this.stepType !== FunnelInputTypeEnum.Confirmation
            ? inputs.at(1).get('label').value
            : inputs.at(0).get('label').value;
        const rejectButtonStyles =
          inputs.at(1).value.button_styles && inputs.at(1).value.button_styles.style
            ? inputs.at(1).value.button_styles.style
            : defaultRejectButtonStyles.style;

        this.previewRejectButton = {
          label: this.getHtml(addDummyValues(rejectLabel, this.funnelPathVariables, this.product, this.discount)),
          ...this.extractButtonStyles(rejectButtonStyles),
        };
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Reset cache when preview or partialEdit changes
    if (changes.preview || changes.partialEdit || changes.product || changes.discount) {
      this.resetCache();

      // Handle ChangeVariant step type
      if (
        changes.product &&
        this.product &&
        this.product.id &&
        this.stepType === CustomStepCategoryEnum.ChangeVariant
      ) {
        this.campaignProductLoading = true;
        this.campaignProductService.get(this.product.id).subscribe({
          next: (product: CampaignProduct) => {
            this.campaignProductLoading = false;
            this.selectedCampaignProduct = product;
            this.storageService.set('selectedStepProduct', product);
            this.initializeVariantSelections();
          },
          error: (error) => {
            this.campaignProductLoading = false;
            this.selectedCampaignProduct = this.product;
            this.handleError(error);
            // Set variants to null since API call failed - no variants available
            if (this.selectedCampaignProduct && this.selectedCampaignProduct.product) {
              this.selectedCampaignProduct.product.variants = null;
            }
            this.variantSelections = {};
          },
        });
      }

      // Handle ReviseOrder (Exchangeables) in PREVIEW MODE ONLY
      if (changes.product && this.stepType === CustomStepCategoryEnum.ReviseOrder && this.preview) {
        this.loadExchangeablesForPreview();
      }
    }

    if (changes.activeDevice) {
      setEmulatorWidth(this.getDeviceWidth());
      if (this.stepMedia) {
        if (this.stepMedia.fixedImage[this.activeDevice].file) {
          this.noStepMedia = false;
        } else if (this.stepMedia.fixedImage.productImage) {
          this.noStepMedia = false;
        } else if (this.stepMedia.embedVideo.url && this.stepMedia.embedVideo.sanitizedURL) {
          this.noStepMedia = false;
        } else {
          this.noStepMedia = true;
        }
      }

      if (this.stepResponseMedia) {
        if (this.stepResponseMedia.fixedImage[this.activeDevice].file) {
          this.noResponseMedia = false;
        } else if (this.stepResponseMedia.fixedImage.productImage) {
          this.noResponseMedia = false;
        } else if (this.stepResponseMedia.embedVideo.url && this.stepResponseMedia.embedVideo.sanitizedURL) {
          this.noResponseMedia = false;
        } else {
          this.noResponseMedia = true;
        }
      }
    }

    if (changes.theme) {
      this.applyThemeColor(changes.theme.currentValue);
    }

    if (this.stepMedia) {
      this.extractStepMedia();
    }

    if (this.stepResponseMedia) {
      this.extractResponseMedia();
    }

    // Update UI states when inputs change
    this.updateExchangeableUIStates();
  }

  addSubscription(subscription: Subscription): void {
    this.subscriptions.push(subscription);
  }

  extractStepMedia() {
    this.noStepMedia = true;

    switch (this.stepMedia.category) {
      case StepMediaCategory.Fixed:
        switch (this.stepMedia.fixedImage.category) {
          case StepFixedMediaCategory.Gallery:
            if (this.stepMedia.fixedImage.productImage) {
              this.selectedImage =
                this.stepMedia.fixedImage.productImage.file.original || this.stepMedia.fixedImage.productImage.file;
              this.noStepMedia = false;
            } else {
              this.selectedImage = null;
            }
            break;

          case StepFixedMediaCategory.Upload:
            if (this.stepMedia.fixedImage[this.activeDevice].file) {
              this.noStepMedia = false;
            }
            break;
        }
        break;

      case StepMediaCategory.Embed:
        if (this.stepMedia.embedVideo.url) {
          this.noStepMedia = false;
        } else {
          this.videoUrl = null;
        }
        break;
    }

    if (this.noStepMedia) {
      if (this.productPlaceholderUrl) {
        this.placeholder = this.productPlaceholderUrl;
      } else if (this.stepMedia.placeholderImage) {
        this.placeholder = this.stepMedia.placeholderImage;
      } else {
        this.placeholder = null;
      }
    }
  }

  extractResponseMedia() {
    this.noResponseMedia = true;

    switch (this.stepResponseMedia.category) {
      case StepMediaCategory.Fixed:
        switch (this.stepResponseMedia.fixedImage.category) {
          case StepFixedMediaCategory.Gallery:
            if (this.stepResponseMedia.fixedImage.productImage) {
              this.selectedResponseImage =
                this.stepResponseMedia.fixedImage.productImage.file.original ||
                this.stepResponseMedia.fixedImage.productImage.file;
              this.noResponseMedia = false;
            } else {
              this.selectedResponseImage = null;
            }
            break;

          case StepFixedMediaCategory.Upload:
            if (this.stepResponseMedia.fixedImage[this.activeDevice].file) {
              this.noResponseMedia = false;
            }
            break;
        }
        break;

      case StepMediaCategory.Embed:
        if (this.stepResponseMedia.embedVideo.url) {
          this.noResponseMedia = false;
        } else {
          this.videoUrl = null;
        }
        break;
    }
  }

  getProductSets() {
    this.relatedProductSetService
      .list({ page: 1, page_size: config.maxPageSize })
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data: Pager) => {
          let relatedProductSets: { id: number | string; text: string }[] = [];
          data.results.forEach((item: RelatedProductSet) => {
            relatedProductSets.push({ id: item.id, text: item.name });
          });
          this.relatedProductSets = relatedProductSets;

          if (this.actions.value.exchangeable_set_types.length) {
            this.exchangeableSetTypes = this.relatedProductSets.filter((productSet) =>
              this.actions.value.exchangeable_set_types.includes(productSet.id)
            );
            this.stepProductsPreview.loading = true;
            this.exchangeableSetTypeSelected();
          }
        },
        (error) => {
          this.handleError(error);
        }
      );
  }

  exchangeableSetTypeSelected() {
    let ids = [];
    if (this.exchangeableSetTypes && this.exchangeableSetTypes.length) {
      this.exchangeableSetTypes.forEach((item) => {
        ids.push(item.id);
      });

      this.actions.patchValue({
        exchangeable_set_types: ids,
      });
    } else {
      this.exchangeableSetTypes = [];
      this.stepProductsPreview.loading = false;
    }

    this.getExchangeableSets(ids, this.exchangeableSetTypes);
  }

  getExchangeableSets(set_type_ids?: string[] | number[], filterData = []) {
    if (set_type_ids) {
      const params = {
        page: 1,
        page_size: config.maxPageSize,
        set_type__in: set_type_ids.join(','),
      };
      this.loading = true;
      this.exchangeablesSetService
        .list(params)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (data: Pager) => {
            this.loading = false;
            if (filterData.length > 0) {
              let exchangeableSets = [];
              filterData.forEach((id) => {
                let es = data.results.filter((item) => item.id === id);
                if (es.length > 0) {
                  exchangeableSets.push(es[0]);
                }
              });
              this.exchangeableSets = exchangeableSets;
            }
            this.unassignedExchangeableSets = data.results.slice();

            if (this.actions.value.exchangeable_set.length) {
              this.exchangeableSets = this.unassignedExchangeableSets.filter((set) =>
                this.actions.value.exchangeable_set.includes(set.id)
              );

              if (this.exchangeableSets.length) {
                this.getPreview(this.exchangeableSets[0].id);
              }
            }
          },
          (error) => {
            this.handleError(error);
          }
        );
    }
  }

  getPreview(id: string | number) {
    if (!this.stepProductsPreview.data.length) {
      this.stepProductsPreview.loading = true;
    }

    this.exchangeablesSetService
      .preview(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data: any) => {
          this.stepProductsPreview = { data, loading: false };
          this.stepEmulatorService.updatePreviewProducts(this.stepProductsPreview);
        },
        (error) => {
          this.stepProductsPreview = {
            data: [],
            loading: false,
          };
          this.stepEmulatorService.updatePreviewProducts(this.stepProductsPreview);
          this.handleError(error);
        }
      );
  }

  get banner(): SafeHtml {
    if (this.preview && !this.partialEdit) {
      if (!this.cacheInitialized) {
        this.initializeCache();
      }
      return this.cachedBanner;
    }

    return this.preview
      ? this.getHtml(
          addDummyValues(this.form.get('banner').value, this.funnelPathVariables, this.product, this.discount)
        )
      : this.getHtml(this.stepTextual.banner);
  }

  get label() {
    if (this.preview && !this.partialEdit) {
      if (!this.cacheInitialized) {
        this.initializeCache();
      }
      return this.cachedLabel;
    }

    return this.preview
      ? this.getHtml(
          addDummyValues(this.form.get('label').value, this.funnelPathVariables, this.product, this.discount)
        )
      : this.getHtml(this.stepTextual.body.label);
  }

  get subtitle() {
    if (this.preview && !this.partialEdit) {
      if (!this.cacheInitialized) {
        this.initializeCache();
      }
      return this.cachedSubtitle;
    }

    return this.preview
      ? this.getHtml(
          addDummyValues(this.form.get('subtitle').value, this.funnelPathVariables, this.product, this.discount)
        )
      : this.getHtml(this.stepTextual.body.subtitle);
  }

  get content() {
    if (this.preview && !this.partialEdit) {
      if (!this.cacheInitialized) {
        this.initializeCache();
      }
      return this.cachedContent;
    }

    return this.preview
      ? this.getHtml(
          addDummyValues(this.form.get('content').value, this.funnelPathVariables, this.product, this.discount)
        )
      : this.getHtml(this.stepTextual.body.content);
  }

  get hasContent(): boolean {
    if (this.preview && !this.partialEdit) {
      if (!this.cacheInitialized) {
        this.initializeCache();
      }
      return this.cachedHasContent;
    }

    const rawContent = this.preview
      ? addDummyValues(this.form.get('content').value, this.funnelPathVariables, this.product, this.discount)
      : this.stepTextual && this.stepTextual.body && this.stepTextual.body.content;

    return !!(rawContent && rawContent.toString().trim());
  }

  get hasSubtitle(): boolean {
    if (this.preview && !this.partialEdit) {
      if (!this.cacheInitialized) {
        this.initializeCache();
      }
      return this.cachedHasSubtitle;
    }

    const rawSubtitle = this.preview
      ? addDummyValues(this.form.get('subtitle').value, this.funnelPathVariables, this.product, this.discount)
      : this.stepTextual && this.stepTextual.body && this.stepTextual.body.subtitle;

    return !!(rawSubtitle && rawSubtitle.toString().trim());
  }

  get hasResponse(): boolean {
    const responseContent = this.stepResponseScreen && this.stepResponseScreen.responseContent;
    return !!(responseContent && responseContent.toString().trim());
  }

  get confirmButton() {
    return this.getHtml(this.stepButtons.confirmButton.content);
  }

  get rejectButton() {
    return this.getHtml(this.stepButtons.rejectButton.content);
  }

  get responseTitle() {
    return this.getHtml(this.stepResponseScreen.titleContent);
  }

  get response() {
    return this.getHtml(this.stepResponseScreen.responseContent);
  }

  getHtml(content: string) {
    return this.sanitizer.bypassSecurityTrustHtml(updateFontSizes(content || ''));
  }

  private hasHtmlContent(content: string): boolean {
    let hasContent = false;
    if (content) {
      const trimmed = content.trim();
      if (trimmed) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = trimmed;
        const textContent = tempDiv.textContent || tempDiv.innerText || '';
        hasContent = textContent.trim().length > 0;
      }
    }
    return hasContent;
  }

  private initializeCache(): void {
    this.cachedBanner = this.getHtml(
      addDummyValues(this.form.get('banner').value, this.funnelPathVariables, this.product, this.discount)
    );
    this.cachedLabel = this.getHtml(
      addDummyValues(this.form.get('label').value, this.funnelPathVariables, this.product, this.discount)
    );

    const rawSubtitle = addDummyValues(
      this.form.get('subtitle').value,
      this.funnelPathVariables,
      this.product,
      this.discount
    );
    this.cachedSubtitle = this.getHtml(rawSubtitle);
    this.cachedHasSubtitle = this.hasHtmlContent(rawSubtitle);

    const rawContent = addDummyValues(
      this.form.get('content').value,
      this.funnelPathVariables,
      this.product,
      this.discount
    );
    this.cachedContent = this.getHtml(rawContent);
    this.cachedHasContent = this.hasHtmlContent(rawContent);
    this.cacheInitialized = true;
  }

  private resetCache(): void {
    this.cacheInitialized = false;
    this.cachedBanner = null;
    this.cachedLabel = null;
    this.cachedSubtitle = null;
    this.cachedContent = null;
    this.cachedHasSubtitle = false;
    this.cachedHasContent = false;
  }

  get isStepMedia() {
    return this.stepEmulatorService.selectedMediaPanel === StepMediaPanels.Step;
  }

  get isResponseMedia() {
    return this.stepEmulatorService.selectedMediaPanel === StepMediaPanels.Response;
  }

  get isStepFixed() {
    return this.stepMedia.category === StepMediaCategory.Fixed;
  }

  get isResponseFixed() {
    return this.stepResponseMedia.category === StepMediaCategory.Fixed;
  }

  get isStepUpload() {
    return this.stepMedia.fixedImage.category === StepFixedMediaCategory.Upload;
  }

  get isResponseUpload() {
    return this.stepResponseMedia.fixedImage.category === StepFixedMediaCategory.Upload;
  }

  get isStepGallery() {
    return this.stepMedia.fixedImage.category === StepFixedMediaCategory.Gallery;
  }

  get isResponseGallery() {
    return this.stepResponseMedia.fixedImage.category === StepFixedMediaCategory.Gallery;
  }

  get isStepEmbed() {
    return this.stepMedia.category === StepMediaCategory.Embed;
  }

  get isResponseEmbed() {
    return this.stepResponseMedia.category === StepMediaCategory.Embed;
  }

  get isMobile() {
    return this.activeDevice === StepEmulatorDevices.Mobile;
  }

  get isTablet() {
    return this.activeDevice === StepEmulatorDevices.Tablet;
  }

  get isDesktop() {
    return this.activeDevice === StepEmulatorDevices.Desktop;
  }

  get hasLogo() {
    return this.campaign && this.campaign.id && this.campaign.logo && this.campaign.logo.file;
  }

  get hasMobileLogo() {
    return this.campaign && this.campaign.id && this.campaign.mobile_logo && this.campaign.mobile_logo.file;
  }

  getDeviceWidth(): number {
    if (this.isMobile) {
      return StepEmulatorDeviceWidths.Mobile;
    } else if (this.isTablet) {
      return StepEmulatorDeviceWidths.Tablet;
    }
    return StepEmulatorDeviceWidths.Desktop;
  }

  applyStyles() {
    let styles = {},
      padding = '20px';
    if (this.isDesktop) {
      padding = '50px';
    }

    if (!this.hasBanner || !this.stepTextual.banner) {
      styles = {
        'padding-top': padding,
      };
    }

    return styles;
  }

  applyThemeColor(color: string) {
    document.documentElement.style.setProperty('--label-border-color', color || '#2eb3c9');
  }

  exchangeableProductDiscount(product) {
    return Math.round(100 - ((+product.price * product.quantity) / +product.retail_price) * 100);
  }

  get getConfirmFontColor() {
    if (
      this.stepButtons.confirmButton.type === StepButtonControlTypes.Theme &&
      (this.outlineShapes.includes(this.stepButtons.confirmButton.style) ||
        this.stepButtons.confirmButton.style === StepButtonShapes.TextOnly)
    ) {
      return this.stepButtons.confirmButton.brandFont;
    } else {
      return this.stepButtons.confirmButton.fontColor;
    }
  }

  get getRejectFontColor() {
    if (
      this.stepButtons.rejectButton.type === StepButtonControlTypes.Theme &&
      (this.outlineShapes.includes(this.stepButtons.rejectButton.style) ||
        this.stepButtons.rejectButton.style === StepButtonShapes.TextOnly)
    ) {
      return this.stepButtons.rejectButton.brandFont;
    } else {
      return this.stepButtons.rejectButton.fontColor;
    }
  }

  get getConfirmBorderColor() {
    let result;
    if (this.stepButtons.confirmButton.type === StepButtonControlTypes.Custom) {
      result = this.stepButtons.confirmButton.borderColor;
    } else {
      if (this.stepButtons.confirmButton.isBorderDisabled) {
        result = transparent;
      } else {
        result = this.stepButtons.confirmButton.brandBorder;
      }
    }
    return result;
  }

  get getRejectBorderColor() {
    let result;
    if (this.stepButtons.rejectButton.type === StepButtonControlTypes.Custom) {
      result = this.stepButtons.rejectButton.borderColor;
    } else {
      if (this.stepButtons.rejectButton.isBorderDisabled) {
        result = transparent;
      } else {
        result = this.stepButtons.rejectButton.brandBorder;
      }
    }
    return result;
  }

  get getConfirmBackgroundColor() {
    let result;
    if (this.stepButtons.confirmButton.type === StepButtonControlTypes.Custom) {
      result = this.stepButtons.confirmButton.backgroundColor;
    } else {
      if (this.stepButtons.confirmButton.isBackgroundDisabled) {
        result = transparent;
      } else {
        result = this.stepButtons.confirmButton.brandBackground;
      }
    }
    return result;
  }

  get getRejectBackgroundColor() {
    let result;
    if (this.stepButtons.rejectButton.type === StepButtonControlTypes.Custom) {
      result = this.stepButtons.rejectButton.backgroundColor;
    } else {
      if (this.stepButtons.rejectButton.isBackgroundDisabled) {
        result = transparent;
      } else {
        result = this.stepButtons.rejectButton.brandBackground;
      }
    }
    return result;
  }

  get isStepMediaEnabled() {
    return this.stepMedia.category !== StepMediaCategory.NoMedia;
  }

  get isResponseMediaEnabled() {
    return this.stepResponseMedia.category !== StepMediaCategory.NoMedia;
  }

  get hasBanner(): boolean {
    const textual = this.layout.find((element) => element.type === StepElementTypes.Textual);
    return textual && (textual.layout as StepTextualLayout).banner && !!this.form.get('banner').value;
  }

  get hasTextualElements(): boolean {
    return (
      (this.hasBanner && !this.isHidden(StepSectionWidths.Banner)) ||
      !this.isHidden(StepSectionWidths.Label) ||
      !this.isHidden(StepSectionWidths.Subtitle) ||
      !this.isHidden(StepSectionWidths.Content)
    );
  }

  get isCancellationResponse() {
    return this.confirmationStepType && +this.confirmationStepType === FunnelInputTypeEnum.InputActionStatus;
  }

  get isTypeSelectDropdown() {
    return this.form.get('type').value === FunnelInputTypeEnum.Select;
  }

  get isTypeChoice() {
    return (
      this.form.get('type').value === FunnelInputTypeEnum.Choice ||
      this.form.get('type').value === FunnelInputTypeEnum.Radio
    );
  }

  get isTypeButtons() {
    return this.form.get('type').value === FunnelInputTypeEnum.Choice && buttonLayoutSteps.indexOf(this.stepType) > -1;
  }

  isHidden(type: StepSectionWidths): boolean {
    return this.form.get('content_config').get(type).get('is_hidden').value;
  }

  isResponseHidden(type: StepSectionWidths): boolean {
    return this.form.get('response_data.content_config').get(type).get('is_hidden').value;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }

  protected readonly getCampaignProductImageUrl = getCampaignProductImageUrl;

  extractButtonStyles(styles: string) {
    if (!styles) {
      return {
        backgroundColor: '',
        color: '',
        borderRadius: '',
        borderColor: '',
        borderWidth: '1px',
      };
    }

    const styleMap = styles.split(';').reduce(
      (acc, style) => {
        const [key, value] = style.split(':').map((s) => s.trim());
        if (key && value) {
          acc[key] = value.replace('var(--theme_color)', this.theme);
        }
        return acc;
      },
      {} as Record<string, string>
    );

    return {
      backgroundColor: styleMap['background-color'] || '',
      color: styleMap['color'] || '',
      borderRadius: styleMap['border-radius'] || '',
      borderColor: styleMap['border-color'] || '',
      borderWidth: styleMap['border-width'] || '1px',
    };
  }

  getWidthValue(responseDataFlag: boolean, type: StepSectionWidths): string {
    if (this.form) {
      let widthConfig: FormGroup = this.form;
      const config = responseDataFlag ? 'response_data.content_config' : 'content_config';
      const paths = config.split('.');

      for (const path of paths) {
        const control = widthConfig.get(path);
        widthConfig = control as FormGroup;
      }

      const control = widthConfig.get(type);
      const value = control.get(this.activeDevice.toString());
      const percentage = value && value.value ? value.value : 100;

      // For StaticImage, return pixel values based on device max-widths
      if (type === StepSectionWidths.StaticImage) {
        const maxWidths = {
          [StepEmulatorDevices.Mobile]: 250,
          [StepEmulatorDevices.Tablet]: 350,
          [StepEmulatorDevices.Desktop]: 375,
        };

        const maxWidth = maxWidths[this.activeDevice] || 375;
        const pixelWidth = Math.round((percentage / 100) * maxWidth);
        return pixelWidth + 'px';
      }

      return percentage + '%';
    }
    return '100%';
  }

  onElementClick(element: StepElements, event: MouseEvent, panel?: StepMediaPanels): void {
    event.stopPropagation();
    event.preventDefault();
    if (panel) {
      this.stepEmulatorService.selectedMediaPanel = panel;
      if (panel === StepMediaPanels.Response) {
        this.stepEmulatorService.responseScreenStateSubject.next(true);
      } else {
        this.stepEmulatorService.responseScreenStateSubject.next(false);
      }
    }
    // Only toggle if element is not already visible
    if (!this.stepEmulatorService.isElementVisible(element)) {
      if (panel) {
        this.stepEmulatorService.toggleElement(element, true);
      } else {
        this.stepEmulatorService.toggleElement(element, false);
      }
    }
  }

  getQuantityOptions(maxQuantity: number): number[] {
    const options = [];
    for (let i = 1; i <= maxQuantity; i++) {
      options.push(i);
    }
    return options;
  }

  private loadExchangeablesForPreview(): void {
    if (this.actions && this.product) {
      const exchangeableIndex = this.actions.value.exchangeable_index;
      const exchangeableSetTypes = this.actions.value.exchangeable_set_types;
      const exchangeableSet = this.actions.value.exchangeable_set;

      // Type 2: Fixed Product Index
      if (exchangeableIndex !== null) {
        if (this.product.exchangeable_products && this.product.exchangeable_products.length > exchangeableIndex) {
          const selectedExchangeable = this.product.exchangeable_products[exchangeableIndex];
          this.stepEmulatorService.updatePreviewProducts({
            data: [selectedExchangeable],
            loading: false,
          });
        } else {
          this.stepEmulatorService.updatePreviewProducts({ data: [], loading: false });
        }
      } else if (exchangeableSetTypes && exchangeableSetTypes.length > 0) {
        // Type 3: Advanced Sets (from API)
        if (exchangeableSet && exchangeableSet.length > 0) {
          this.stepEmulatorService.updatePreviewProducts({ data: [], loading: true });
          this.getProductSets();
        } else {
          this.stepEmulatorService.updatePreviewProducts({ data: [], loading: false });
        }
      } else {
        // Type 1: Product Options (default, from product.exchangeable_products)
        if (this.product.exchangeable_products && this.product.exchangeable_products.length) {
          this.stepEmulatorService.updatePreviewProducts({
            data: this.product.exchangeable_products,
            loading: false,
          });
        } else {
          this.stepEmulatorService.updatePreviewProducts({ data: [], loading: false });
        }
      }
    } else {
      this.stepEmulatorService.updatePreviewProducts({ data: [], loading: false });
    }
  }

  private updateExchangeableUIStates(): void {
    const hasNoExchangeableProducts = !this.stepProductsPreview.data || this.stepProductsPreview.data.length === 0;
    const quantityTypeNotNone =
      this.actions &&
      this.actions.get('quantity_type') &&
      this.actions.get('quantity_type').value !== this.quantityType.None;

    this.shouldShowQuantityDropdown = hasNoExchangeableProducts && !!quantityTypeNotNone;
    this.shouldShowPlaceholderProducts = hasNoExchangeableProducts && !this.shouldShowQuantityDropdown;
  }

  get groupedVariants(): { optionName: string; variants: any[] }[] {
    // Check if we need to recalculate
    const currentProductId = this.selectedCampaignProduct && this.selectedCampaignProduct.id;
    if (currentProductId !== this.lastCampaignProductId) {
      this.lastCampaignProductId = currentProductId;
      this.cachedGroupedVariants = this.calculateGroupedVariants();
    }
    return this.cachedGroupedVariants;
  }

  private calculateGroupedVariants(): { optionName: string; variants: any[] }[] {
    let result = [];

    if (
      this.selectedCampaignProduct &&
      this.selectedCampaignProduct.product &&
      this.selectedCampaignProduct.product.variants &&
      this.selectedCampaignProduct.product.variants.length > 0
    ) {
      const variantsMap = new Map<string, any[]>();

      this.selectedCampaignProduct.product.variants.forEach((variant) => {
        if (variant.options && variant.options.length > 0) {
          const optionName = variant.options[0].name;
          const optionValue = variant.options[0].value;

          if (!variantsMap.has(optionName)) {
            variantsMap.set(optionName, []);
          }

          variantsMap.get(optionName).push({
            ...variant,
            displayValue: this.capitalizeVariantValue(optionValue),
            imageUrl: this.getVariantImageUrl(variant),
          });
        }
      });

      variantsMap.forEach((variants, optionName) => {
        result.push({ optionName, variants });
      });
    }

    return result;
  }

  capitalizeVariantValue(value: string): string {
    if (!value) {
      return value;
    }
    return value
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  hasVariants(): boolean {
    let hasVariants = false;
    if (
      this.selectedCampaignProduct &&
      this.selectedCampaignProduct.product &&
      this.selectedCampaignProduct.product.variants
    ) {
      hasVariants = this.selectedCampaignProduct.product.variants.length > 0;
    }
    return hasVariants;
  }

  getVariantImageUrl(variant: any): string {
    let imageUrl = null;
    if (variant.image && variant.image.file) {
      if (variant.image.file.small) {
        imageUrl = variant.image.file.small;
      } else if (variant.image.file.medium) {
        imageUrl = variant.image.file.medium;
      } else if (variant.image.file.original) {
        imageUrl = variant.image.file.original;
      } else {
        imageUrl = variant.image.file;
      }
    }
    return imageUrl;
  }

  hasVariantImages(variants: any[]): boolean {
    return variants.some((variant) => variant.imageUrl);
  }

  trackVariantBy(index: number, variant: any): any {
    return variant.id || variant.displayValue || index;
  }

  get isStandardVariant(): boolean {
    return (
      this.selectedCampaignProduct &&
      this.selectedCampaignProduct.product &&
      this.selectedCampaignProduct.product.variant_type === VariantTypeEnum.Standard
    );
  }

  get isBundledVariant(): boolean {
    return (
      this.selectedCampaignProduct &&
      this.selectedCampaignProduct.product &&
      this.selectedCampaignProduct.product.variant_type === VariantTypeEnum.Bundled
    );
  }

  get shouldShowMultipleDropdowns(): boolean {
    let shouldShow = false;
    // Standard variants always show dropdowns
    if (this.isStandardVariant) {
      shouldShow = true;
    } else {
      // Bundled variants show dropdowns only if <= 10 bundle quantity
      shouldShow = this.isBundledVariant && this.selectedCampaignProduct.bundle_quantity <= 10;
    }
    return shouldShow;
  }

  get shouldShowVariantTable(): boolean {
    // Only show table for bundled variants with > 10 bundle quantity
    // Standard variants never use table format
    return this.isBundledVariant && this.selectedCampaignProduct.bundle_quantity > 10;
  }

  getBundleDropdownArray(): number[] {
    let arrayResult = [];
    // For standard variants, always return [0] for single dropdown set
    if (this.isStandardVariant) {
      arrayResult = [0];
    } else {
      // For bundled variants, return array based on bundle quantity
      if (this.shouldShowMultipleDropdowns || this.shouldShowVariantTable) {
        arrayResult = Array.from({ length: this.selectedCampaignProduct.bundle_quantity }, (_, i) => i);
      }
    }
    return arrayResult;
  }

  get variantOptionCategories(): string[] {
    let categories = [];
    if (
      this.selectedCampaignProduct &&
      this.selectedCampaignProduct.product &&
      this.selectedCampaignProduct.product.variants
    ) {
      const categorySet = new Set<string>();
      this.selectedCampaignProduct.product.variants.forEach((variant) => {
        if (variant.options) {
          variant.options.forEach((option) => {
            categorySet.add(option.name);
          });
        }
      });
      categories = Array.from(categorySet).sort();
    }
    return categories;
  }

  getVariantOptionValues(categoryName: string): string[] {
    let values = [];
    if (
      this.selectedCampaignProduct &&
      this.selectedCampaignProduct.product &&
      this.selectedCampaignProduct.product.variants
    ) {
      const valueSet = new Set<string>();
      this.selectedCampaignProduct.product.variants.forEach((variant) => {
        if (variant.options) {
          const option = variant.options.find((opt) => opt.name === categoryName);
          if (option) {
            valueSet.add(option.value);
          }
        }
      });
      values = Array.from(valueSet).sort();
    }
    return values;
  }

  getSelectedVariantOptions(bundleIndex: number = 0): { [categoryName: string]: string } {
    const selectedOptions: { [categoryName: string]: string } = {};
    this.variantOptionCategories.forEach((category) => {
      const controlName = `variant_${bundleIndex}_${category.toLowerCase().replace(/\s+/g, '_')}`;
      const value = this.variantSelections[controlName];
      if (value && value !== '') {
        selectedOptions[category] = value;
      }
    });
    return selectedOptions;
  }

  hasAllOptionsSelected(bundleIndex: number = 0): boolean {
    const selectedOptions = this.getSelectedVariantOptions(bundleIndex);
    const requiredCategories = this.variantOptionCategories;

    const hasAll = requiredCategories.length > 0 && requiredCategories.every((category) => selectedOptions[category]);

    return hasAll;
  }

  findVariantByOptions(selectedOptions: { [categoryName: string]: string }): any {
    let foundVariant = null;
    if (
      this.selectedCampaignProduct &&
      this.selectedCampaignProduct.product &&
      this.selectedCampaignProduct.product.variants
    ) {
      foundVariant = this.selectedCampaignProduct.product.variants.find((variant) => {
        let matches = false;
        if (variant.options) {
          const categoryNames = Object.keys(selectedOptions);
          if (categoryNames.length > 0) {
            matches = categoryNames.every((categoryName) => {
              const option = variant.options.find((opt) => opt.name === categoryName);
              return option && option.value === selectedOptions[categoryName];
            });
          }
        }
        return matches;
      });
    }
    return foundVariant;
  }

  getCurrentVariantImage(bundleIndex: number = 0): string {
    const selectedOptions = this.getSelectedVariantOptions(bundleIndex);
    const variant = this.findVariantByOptions(selectedOptions);

    let imageUrl = null;
    if (variant && variant.image && variant.image.file) {
      imageUrl = variant.image.file.original;
    }

    if (!imageUrl) {
      // Fallback to campaign product image or default
      if (this.selectedCampaignProduct && this.selectedCampaignProduct.image) {
        imageUrl = getCampaignProductImageUrl(this.selectedCampaignProduct.image);
      }
    }

    if (!imageUrl) {
      imageUrl = this.productPlaceholderUrl || '/assets/stepAssets/product-placeholder.png';
    }

    return imageUrl;
  }

  hasCurrentVariantImage(bundleIndex: number = 0): boolean {
    const selectedOptions = this.getSelectedVariantOptions(bundleIndex);
    const variant = this.findVariantByOptions(selectedOptions);

    let hasVariantImage = false;
    if (variant && variant.image && variant.image.file) {
      hasVariantImage = true;
    }

    return hasVariantImage;
  }

  getBundleDropdownCount(): number {
    let count = 1;
    // For standard variants, always 1 dropdown set
    if (this.isStandardVariant) {
      count = 1;
    } else {
      // For bundled variants, use bundle quantity
      if (this.selectedCampaignProduct && this.selectedCampaignProduct.bundle_quantity) {
        count = this.selectedCampaignProduct.bundle_quantity;
      }
    }
    return count;
  }

  getVariantControlName(bundleIndex: number, categoryName: string): string {
    return `variant_${bundleIndex}_${categoryName.toLowerCase().replace(/\s+/g, '_')}`;
  }

  getVariantValue(bundleIndex: number, categoryName: string): string {
    const controlName = this.getVariantControlName(bundleIndex, categoryName);
    return this.variantSelections[controlName] || '';
  }

  onVariantOptionChange(bundleIndex: number, categoryName: string, value: string): void {
    const controlName = `variant_${bundleIndex}_${categoryName.toLowerCase().replace(/\s+/g, '_')}`;
    this.variantSelections[controlName] = value;
  }

  getVariantDisplayName(variant: any): string {
    let displayName = '';
    if (variant && variant.options && variant.options.length > 0) {
      displayName = this.capitalizeVariantValue(variant.options[0].value);
    }
    return displayName;
  }

  updateVariantQuantity(variant: any, delta: number): void {
    if (variant) {
      const newQuantity = (variant.quantity || 0) + delta;
      if (newQuantity >= 0) {
        variant.quantity = newQuantity;
      }
    }
  }

  hasAnyVariantImages(): boolean {
    let hasImages = false;
    if (
      this.selectedCampaignProduct &&
      this.selectedCampaignProduct.product &&
      this.selectedCampaignProduct.product.variants
    ) {
      hasImages = this.selectedCampaignProduct.product.variants.some((variant) => {
        return variant.image && variant.image.file;
      });
    }
    return hasImages;
  }

  private initializeVariantSelections(): void {
    if (this.selectedCampaignProduct && this.selectedCampaignProduct.product) {
      const bundleCount = this.getBundleDropdownCount();
      const categories = this.variantOptionCategories;

      // Clear existing selections
      this.variantSelections = {};

      for (let bundleIndex = 0; bundleIndex < bundleCount; bundleIndex++) {
        categories.forEach((category) => {
          const controlName = this.getVariantControlName(bundleIndex, category);
          const values = this.getVariantOptionValues(category);

          this.variantSelections[controlName] = '';
        });
      }
    }
  }
}
